// @ts-strict-ignore
import React from 'react'
import { removeWhitespaceAndSpecialChars } from '../../helpers/commons'
import ProviderLogoPlatinum from '../provider-logo'

interface ImageJson {
  src: string
}

interface ImageCarouselJsonBody {
  title: string
  images: ImageJson[]
}

interface ImageCarouselProps {
  name: string
  jsonBody: ImageCarouselJsonBody
}

const ImageCarousel = ({ name, jsonBody }: ImageCarouselProps) => {
  try {
    return (
      <div id={removeWhitespaceAndSpecialChars(name)} className='image-carousel'>
        {jsonBody.title && <div className='image-carousel__title'>{jsonBody.title}</div>}
        <ProviderLogoPlatinum
          name='business-loans-ppc-image-carousel'
          variant='ppc'
          provider={jsonBody.images.map((image) => ({
            id: image.name,
            name: image.name,
            images: {
              money: image.src,
              uswitch: image.src,
              confused: image.src,
            },
          }))}
        />
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default ImageCarousel
